import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3-mobile" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "is-size-5 bold-text" }
const _hoisted_4 = {
  key: 0,
  class: "is-size-6"
}
const _hoisted_5 = { class: "has-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "button is-danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(null)))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button is-primary ml-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close(true)))
        }, "Yes")
      ])
    ])
  ]))
}